import { deleteTwoFactorConfig, getTwoFactorConfig } from '@ukpostbox/client-data';
import { updateTwoFactorConfig } from '@ukpostbox/client-data/lib/Endpoints/UserSettingsEndpoints';
import {
	Button,
	ColourStateSolid,
	FlexAlign,
	FlexGap,
	FlexJustify,
	StackHorizontal,
	StackVertical,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import React, { useEffect, useState } from 'react';
import { useSite } from '../../../../../_Global/Providers/SiteInterfaceProvider';
import { TwoFactorEntry } from '../Components/TwoFactorEntry';
import { TwoFactorConfirmationModal } from '../Components/TwoFactorConfirmationModal';
import { TwoFactorEntryType } from '../TwoFactorTypes';

function TwoFactor() {
	const { t } = useTranslation();
	const { currentLocale, updatePageMeta } = useSite();

	const [authTypes, setAuthTypes] = useState<Array<TwoFactorEntryType>>([]);
	const [recoveryCodes, setRecoveryCodes] = useState<Array<string>>([]);

	const GetAuthConfigs = async () => {
		await getTwoFactorConfig().then((r: any) => {
			console.log('getTwoFactorConfig', r);
			setAuthTypes(r.twoFactorAuthenticationConfigurations);
		});
	};

	const UpdateAuthConfigs = async (value: Array<number>) => {
		await updateTwoFactorConfig(value).then((r: any) => {
			console.log('updateTwoFactorConfig', r);
			if (r) {
				setRecoveryCodes(r.recoveryCodes);
			}
		});
	};

	const RemoveAuthType = async () => {
		await deleteTwoFactorConfig().then(() => setAuthTypes([]));
	};

	useEffect(() => {
		updatePageMeta({
			title: t('settings.loginHistory.title'),
		});
	}, [currentLocale]);

	useEffect(() => {
		GetAuthConfigs();
	}, []);

	return (
		<StackVertical gap={FlexGap.Small}>
			<StackHorizontal align={FlexAlign.Center} justify={FlexJustify.Between} extraClass='mb-xs'>
				<h2 className='mb-0'>{t('settings.twoFactorAuth.title')}</h2>
			</StackHorizontal>
			<p>{t('settings.twoFactorAuth.description')}</p>

			<Button onClick={() => UpdateAuthConfigs([1])} title='Enable' colour={ColourStateSolid.Secondary} />

			<div>
				{authTypes.map((item: any) => (
					<TwoFactorEntry {...item} removeCallback={() => RemoveAuthType()} />
				))}
			</div>

			<TwoFactorConfirmationModal
				isOpen={recoveryCodes.length > 0}
				closeCallback={() => setRecoveryCodes([])}
				recoveryCodes={recoveryCodes}
			/>
		</StackVertical>
	);
}

export default TwoFactor;
